import { css } from 'lit';

export const pimsterStickyWidgetStyle = css`
  .wrapper {
    z-index: 9999;
    cursor: pointer;
    position: fixed;
  }
`;
